import { WarningComponent } from "../svg/warning/warning.component";
import { NgModule } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from "@angular/router";
import { PriceComponent } from "../product/price/price.component";
import { EuroPricePipe } from "../pipes/price.pipe";
import { EventStarsComponent } from "../svg/event-stars/event-stars.component";
import { PasswordInputComponent } from "../customer/login/password-input.component";
import { PhoneLinkDirective } from "../directives/phone-link.directive";
import { ShortenTextPipe } from "../pipes/shortenText.pipe";
import { ShowFormErrorComponent } from "../form/error.show.component";
import { AddressFieldComponent } from "../customer/address-field/address-field.component";
import { AddressSelectorComponent } from "../customer/address-selector/address-selector.component";
import { SanitizePipe } from "../pipes/sanitize.pipe";
import { PositiveOrZeroPipe } from "../pipes/positiveOrZero.pipe";
import { AddressTileComponent } from "../customer/address-tile/address-tile.component";
import { OpeningHoursComponent } from "../location-finder/opening-hours.component";
import { GeaDatePipe } from "../pipes/date.pipe";
import { LoginButtonComponent } from "../customer/login/button/button.component";
import { DistancePipe } from "../pipes/distance.pipe";
import { LocationFinderComponent } from "../location-finder/location-finder.component";
import { OpenstreetmapComponent } from "../location-finder/openstreetmap.component";
import { NotFoundComponent } from "../not-found/not-found.component";
import { ServerErrorComponent } from "../server-error/server-error.component";
import { StructuredDataLocationComponent } from "../structured-data/structured-data.location.component";
import { PencilComponent } from "../svg/pencil/pencil.component";
import { ArrowRightComponent } from "../svg/arrow-right/arrow-right.component";
import { LoadingComponent } from "../svg/loading/loading.component";
import { ErrorComponent } from "../svg/error/error.component";
import { SuccessComponent } from "../svg/success/success.component";
import { SwatchColorComponent } from "../product/swatch-color/swatch-color.component";
import { CmsTileComponent } from "../category/cms-tile/cms-tile.component";
import { ItemComponent } from "../product/item/item.component";
import { ItemBadgeComponent } from "../product/item-badge.component/item-badge.component";
import { WagtailPageComponent } from "../wagtail-page/wagtail-page.component";
import { WagtailElementsComponent } from "../wagtail-page/wagtail-elements.component";
import { WagtailElementComponent } from "../wagtail-page/wagtail-element.component";
import { WagtailImageComponent } from "../wagtail-page/elements/image/image.component";
import { ShareButtonComponent } from "../share-button/share-button.component";
import { MarkdownComponent } from "../html/markdown.component";
import { ShoeWidthComponent } from "../svg/shoe-width/shoe-width.component";
import { MapvaluesPipe } from "../pipes/mapvalues.pipe";

@NgModule({
  imports: [ CommonModule, FormsModule, ReactiveFormsModule, NgbModule, RouterModule, NgOptimizedImage, PriceComponent, EuroPricePipe, EventStarsComponent, PasswordInputComponent, PhoneLinkDirective, ShortenTextPipe, ShowFormErrorComponent ],
  declarations: [
    AddressFieldComponent,
    AddressSelectorComponent,
    SanitizePipe,
    PositiveOrZeroPipe,
    WarningComponent,
    AddressTileComponent,
    OpeningHoursComponent,
    GeaDatePipe,
    LoginButtonComponent,
    DistancePipe,
    LocationFinderComponent,
    OpenstreetmapComponent,
    NotFoundComponent,
    ServerErrorComponent,
    StructuredDataLocationComponent,
    PencilComponent,
    ArrowRightComponent,
    LoadingComponent,
    ErrorComponent,
    SuccessComponent,
    SwatchColorComponent,
    CmsTileComponent,
    ItemComponent,
    ItemBadgeComponent,
    WagtailPageComponent,
    WagtailElementsComponent,
    WagtailElementComponent,
    WagtailImageComponent,
    ShareButtonComponent,
    MarkdownComponent,
    ShoeWidthComponent,
    MapvaluesPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule,
    NgOptimizedImage,
    AddressFieldComponent,
    AddressSelectorComponent,
    AddressTileComponent,
    PriceComponent,
    EuroPricePipe,
    SanitizePipe,
    PositiveOrZeroPipe,
    WarningComponent,
    EventStarsComponent,
    PasswordInputComponent,
    OpeningHoursComponent,
    GeaDatePipe,
    LoginButtonComponent,
    PhoneLinkDirective,
    DistancePipe,
    LocationFinderComponent,
    OpenstreetmapComponent,
    NotFoundComponent,
    ServerErrorComponent,
    StructuredDataLocationComponent,
    PencilComponent,
    ArrowRightComponent,
    LoadingComponent,
    ErrorComponent,
    SuccessComponent,
    SwatchColorComponent,
    CmsTileComponent,
    ItemComponent,
    ItemBadgeComponent,
    ShortenTextPipe,
    WagtailPageComponent,
    WagtailElementsComponent,
    WagtailElementComponent,
    WagtailImageComponent,
    ShareButtonComponent,
    MarkdownComponent,
    ShoeWidthComponent,
    MapvaluesPipe,
    ShowFormErrorComponent
  ],
})
export class SharedModule {}
